import { Typography } from "@material-ui/core";
import MuiBreadcrumbs from "@material-ui/core/Breadcrumbs";
import Fade from "@material-ui/core/Fade";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import React from "react";
import { Link } from "react-router-dom";
import { IBreadcrumbElement } from "../elements/toolbar/breadcrumbTypes";
import { makeThemedStyles } from "../viewcomponents/utils";
const useMuiBreadcrumbsStyles = makeThemedStyles(
  "Breadcrumbs",
  (theme: any) => ({
    root: {
      width: "calc(100% - 40px)",
    },
    ol: {
      flexWrap: "unset",
    },
    li: {
      overflow: "hidden",
      minWidth: "1.9em",
      marginBottom: "1px",
      direction: "initial",
    },
    separator: {
      color: "rgba(255, 255, 255, 0.5)",
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      marginBottom: "2px",
    },
  })
);
const useBreadcrumbSeparatorIconStyles = makeThemedStyles(
  "Breadcrumbs.SeparatorIcon",
  (theme: any) => ({
    root: {
      width: "0.5em",
      height: "0.5em",
    },
    reverse: {
      transform: "rotate(180deg)",
    },
  })
);
const useBreadcrumbStyles = makeThemedStyles(
  "Breadcrumbs.Item",
  (theme: any) => ({
    link: {
      textDecoration: "none",
    },
    text: {
      textOverflow: "ellipsis",
      fontSize: "14px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      maxWidth: "15vw",
      color: "rgba(255, 255, 255, 0.5)",
      "&:hover": { color: "rgba(255, 255, 255, 0.8)" },
    },
  })
);
const useToolTipStyle = makeThemedStyles("", () => ({
  popper: {
    zIndex: 99999999,
  },
  tooltip: {
    lineHeight: "18px",
  },
}));
const MuiToolTip = ({
  title,
  children,
}: {
  title: string;
  children: JSX.Element;
}) => {
  const classes = useToolTipStyle();
  return (
    <Tooltip
      placement="bottom"
      classes={{
        popper: classes.popper,
        tooltip: classes.tooltip,
      }}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
      title={<h1>{title}</h1>}
    >
      {children}
    </Tooltip>
  );
};
const BreadcrumbComponent = (props: {
  item: IBreadcrumbElement;
  disableLink?: boolean;
}) => {
  const classes = useBreadcrumbStyles();
  const { item } = props;
  if (props.disableLink || !item.url) {
    return (
      <>
        {item.icon || null}
        <MuiToolTip title={item.title || ""}>
          <Typography className={classes.text}>{item.title || ""}</Typography>
        </MuiToolTip>
      </>
    );
  }
  return (
    <Link to={item.url} className={classes.link}>
      {item.icon || null}
      <MuiToolTip title={item.title || ""}>
        <Typography className={classes.text}>{item.title || ""}</Typography>
      </MuiToolTip>
    </Link>
  );
};
const BreadcrumbDesign = (props: {
  items: Array<IBreadcrumbElement>;
  rtl?: boolean;
}) => {
  const breadcrumbClasses = useMuiBreadcrumbsStyles();
  const separatorClasses = useBreadcrumbSeparatorIconStyles();
  const { items } = props;
  if (items.length === 0) return null;
  return (
    <MuiBreadcrumbs
      separator={
        <ArrowForwardIosIcon
          className={`${separatorClasses.root} ${
            props.rtl ? separatorClasses.reverse : ""
          }`}
        />
      }
      classes={breadcrumbClasses}
    >
      {items.map((item) => (
        <BreadcrumbComponent key={item.url} item={item} />
      ))}
    </MuiBreadcrumbs>
  );
};
export default BreadcrumbDesign;
